<template>
  <div v-if="showPopup" class="popup-overlay">
    <div class="popup-content">
      <button class="close-btn" @click="closePopup">✕</button>
      <h2>Before You Proceed</h2>
      <p>Please ensure the following before purchasing a plan:</p>
      <ul>
        <li>Your KYC record is updated with a valid mobile number that you currently have access to.</li>
        <li>You have access to the mobile number linked to your Aadhaar.</li>
      </ul>
      <p><strong>Both conditions are mandatory to proceed with the transaction.</strong></p>
      <button class="continue-btn" @click="closePopup">Continue</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "KycReminderPopup",
  data() {
    return {
      showPopup: false,
    };
  },
  mounted() {
    const lastShown = localStorage.getItem("kycPopupLastShown");
    const now = Date.now();

    if (!lastShown || now - parseInt(lastShown) > 24 * 60 * 60 * 1000) {
      this.showPopup = true;
    }
  },
  methods: {
    closePopup() {
      this.showPopup = false;
      localStorage.setItem("kycPopupLastShown", Date.now().toString());
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.popup-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  position: relative;
  text-align: left;
}
.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 18px;
  background: none;
  border: none;
  cursor: pointer;
}
.continue-btn {
  background-color: #1976d2;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 1rem;
}
ul {
  margin-top: 1rem;
  padding-left: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/KycReminderPopup.vue